/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./editSource.vue?vue&type=template&id=bde61370&scoped=true"
import script from "./editSource.vue?vue&type=script&lang=js"
export * from "./editSource.vue?vue&type=script&lang=js"
import style0 from "./editSource.vue?vue&type=style&index=0&id=bde61370&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde61370",
  null
  
)

export default component.exports